export default "__VITE_ASSET__CkbBR7dv__"